const deepCopy = varToCopy => JSON.parse(JSON.stringify(varToCopy));

global._deepCopy = deepCopy;